import { render, staticRenderFns } from "./main.vue?vue&type=template&id=a524b206&scoped=true"
import script from "./logic.js?vue&type=script&lang=js&external"
export * from "./logic.js?vue&type=script&lang=js&external"
import style0 from "./main.vue?vue&type=style&index=0&id=a524b206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a524b206",
  null
  
)

export default component.exports